export default __webpack_public_path__ + "static/media/surgery-v5.e1e3fa93.png";